module.exports = __webpack_public_path__ + "static/media/footer_pnx_logo.6ed18495.svg";